export const SPEAKING_SCORING_SCOPE = {
  FULL_SPEAKING: 'full_speaking',
  SINGLE_PART_PRACTICE: 'single_part_practice',
};

const resolveOriginalSectionIndex = (selectedSectionIndices, localIndex) => {
  const originalIndex = selectedSectionIndices?.[localIndex];
  return Number.isInteger(originalIndex) ? originalIndex : localIndex;
};

export const getSpeakingScoringScope = ({ mode, sections = [], selectedSectionIndices }) => {
  const selectedParts = sections
    .map((_, localIndex) => resolveOriginalSectionIndex(selectedSectionIndices, localIndex) + 1)
    .filter((partNumber) => partNumber >= 1 && partNumber <= 3);

  return mode === 'practice' && selectedParts.length > 0 && selectedParts.length < 3
    ? SPEAKING_SCORING_SCOPE.SINGLE_PART_PRACTICE
    : SPEAKING_SCORING_SCOPE.FULL_SPEAKING;
};

export const buildSpeakingSubmitPayload = ({
  sections = [],
  selectedSectionIndices,
  allQuestions = [],
  audioURLs = {},
  testId,
  testStartTime,
  endTime,
  mode = 'practice',
  status = 'pending_evaluation',
  groupId,
  fullTestAttemptId,
  isSpeakingOptional = false,
}) => {
  const selectedSpeakingParts = [];
  const payload = {
    testId,
    start_time: testStartTime,
    end_time: endTime,
    status,
    scoring_scope: getSpeakingScoringScope({ mode, sections, selectedSectionIndices }),
  };

  if (groupId) {
    payload.groupId = groupId;
    payload.is_speaking_optional = isSpeakingOptional;
  }

  if (groupId && fullTestAttemptId) {
    payload.fullTestAttemptId = fullTestAttemptId;
  }

  sections.forEach((section, localIndex) => {
    const originalIndex = resolveOriginalSectionIndex(selectedSectionIndices, localIndex);
    const partNumber = originalIndex + 1;

    if (partNumber < 1 || partNumber > 3) {
      return;
    }

    selectedSpeakingParts.push(partNumber);
    const partQuestions = allQuestions.filter((question) => question.sectionIdx === localIndex);
    payload[`part${partNumber}`] = {
      partId: section.id,
      questions: partQuestions.map((question) => {
        const globalIdx = allQuestions.findIndex((candidate) => candidate.id === question.id);
        return {
          questionId: question.id,
          questionText: question.question_html || '',
          audioUrl: audioURLs[globalIdx] || null,
        };
      }),
      timeTaken: 0,
    };
  });

  payload.selected_speaking_parts = [...new Set(selectedSpeakingParts)].sort();

  return payload;
};
